
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AcademySection } from './components/AcademySection';
import { ServicesSection } from './components/ServicesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProcessSection } from './components/ProcessSection';
import { WaitlistSection } from './components/WaitlistSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AcademySection />
        <ServicesSection />
        <BenefitsSection />
        <ProcessSection />
        <WaitlistSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
